const measurementId = process.env.REACT_APP_GA4_MEASUREMENT_ID;

const hasMeasurementId = () => Boolean(measurementId && measurementId.trim());

export const initializeAnalytics = () => {
    if (!hasMeasurementId() || typeof window === 'undefined' || typeof document === 'undefined') return;
    if (window.__compclearedGa4Initialized) return;

    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function gtag() {
        window.dataLayer.push(arguments);
    };

    // Default to no analytics storage. A future consent control can grant it with
    // setAnalyticsConsent(true) without changing funnel instrumentation.
    window.gtag('consent', 'default', {
        analytics_storage: 'denied',
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        wait_for_update: 500
    });
    window.gtag('js', new Date());
    window.gtag('config', measurementId, {
        allow_google_signals: false,
        allow_ad_personalization_signals: false
    });

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
    document.head.appendChild(script);
    window.__compclearedGa4Initialized = true;
};

export const setAnalyticsConsent = (granted) => {
    if (!hasMeasurementId() || typeof window === 'undefined' || typeof window.gtag !== 'function') return;
    window.gtag('consent', 'update', {
        analytics_storage: granted ? 'granted' : 'denied'
    });
};

export const trackEvent = (eventName, parameters = {}) => {
    if (!hasMeasurementId() || typeof window === 'undefined' || typeof window.gtag !== 'function') return;
    window.gtag('event', eventName, parameters);
};

export const trackReadinessCheckCompletion = (result) => {
    trackEvent('readiness_check_complete', { result });
};

export const trackPricingCtaClick = (location) => {
    trackEvent('pricing_cta_click', { location, destination: 'signup' });
};

export const trackCheckoutStart = (tier) => {
    trackEvent('begin_checkout', {
        currency: 'USD',
        value: tier === 'annual' ? 149 : 19,
        items: [{ item_id: `pro_${tier}`, item_name: `CompCleared Pro ${tier}` }]
    });
};
